import {
  Box,
  Text,
  Stack,
  Inline,
  IconCheckCircleOutline,
  IconCancelOutline,
  TooltipRenderer,
  IconInfoInverted,
  Skeleton
} from '@machobear/design-system'

type Props = {
  title: string
  value?: string
  errorText?: string
  tooltipText?: string
  showSuccess?: boolean
  isLoading: boolean
}

export const InfoItem = ({
  title,
  value,
  errorText,
  tooltipText,
  showSuccess,
  isLoading
}: Props) => {
  const hasItem = showSuccess ?? value

  if (isLoading) {
    return <Skeleton.Shape height={40} width="100%" />
  }
  return (
    <Box display="flex" alignItems="flexStart">
      <Box marginRight="small">
        {hasItem ? (
          <IconCheckCircleOutline tone="positive" />
        ) : (
          <IconCancelOutline tone="critical" />
        )}
      </Box>
      <Box width="full">
        <Stack space="xxsmall">
          {tooltipText ? (
            <Inline space="xxxsmall" alignY="center">
              <Text size="standard" weight="medium" align="left" tone="tertiary">
                {title}
              </Text>
              <TooltipRenderer
                id="cancelToolTip"
                tooltip={
                  <Box>
                    <Text weight="regular" size="small">
                      {tooltipText}
                    </Text>
                  </Box>
                }
              >
                {({ triggerProps }) => (
                  <Box {...triggerProps} cursor="pointer">
                    <IconInfoInverted />
                  </Box>
                )}
              </TooltipRenderer>
            </Inline>
          ) : (
            <Box style={{ height: '20px' }} display="flex" alignItems="center">
              <Text size="standard" weight="medium" align="left" tone="tertiary">
                {title}
              </Text>
            </Box>
          )}
          {hasItem ? (
            <Text size="standard" weight="medium" align="left">
              {value}
            </Text>
          ) : (
            <Box>
              <Text size="small" weight="regular" align="left" tone="critical">
                {errorText}
              </Text>
            </Box>
          )}
        </Stack>
      </Box>
    </Box>
  )
}
